import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryWithCaseTransform } from './UserApi'

export interface AddCreditCardRequest {
  name: string
  number: string
  expiry: string
  cvv: string
  default: boolean
}

export interface AddCreditCardResponse {
  id: string
}

const paymentMethodApi = createApi({
  reducerPath: 'paymentMethodApi',
  baseQuery: baseQueryWithCaseTransform,
  endpoints: (builder) => ({
    addCreditCard: builder.mutation<
      AddCreditCardResponse,
      AddCreditCardRequest
    >({
      query: (creditCardData) => ({
        url: '/payment-methods',
        method: 'POST',
        body: creditCardData,
      }),
    }),
    deleteCreditCard: builder.mutation<void, string>({
      query: (paymentMethodId) => ({
        url: `/payment-methods/${paymentMethodId}`,
        method: 'DELETE',
      }),
    }),
    setDefaultPaymentMethod: builder.mutation<void, string>({
      query: (paymentMethodId) => ({
        url: `/payment-methods/${paymentMethodId}/default`,
        method: 'PUT',
      }),
    }),
  }),
})

export const {
  useAddCreditCardMutation,
  useDeleteCreditCardMutation,
  useSetDefaultPaymentMethodMutation,
} = paymentMethodApi
export default paymentMethodApi
